import { makeActionCreator } from '../../config/store/utils'

export const GET_RELATED_COMPANIES_AFFIDAVIT = 'GET_RELATED_COMPANIES_AFFIDAVIT'
export const GET_RELATED_COMPANIES_AFFIDAVIT_ERROR = 'GET_RELATED_COMPANIES_AFFIDAVIT_ERROR'
export const GET_RELATED_COMPANIES_AFFIDAVIT_SUCCESS = 'GET_RELATED_COMPANIES_AFFIDAVIT_SUCCESS'
export const onGetRelatedBeneficiariesAffidavit = makeActionCreator(GET_RELATED_COMPANIES_AFFIDAVIT)
export const onGetRelatedBeneficiariesAffidavitError = makeActionCreator(
  GET_RELATED_COMPANIES_AFFIDAVIT_ERROR,
  'payload'
)
export const onGetRelatedCompanyAffidavitSuccess = makeActionCreator(GET_RELATED_COMPANIES_AFFIDAVIT_SUCCESS, 'payload')
export const onGetRelatedCompanyAffidavitError = makeActionCreator(GET_RELATED_COMPANIES_AFFIDAVIT_ERROR, 'payload')
